<tabbed-view [showTabs]="showTabs" [subtitle]="subtitle" [tabs]="tabs"> </tabbed-view>
